import formatPrice from 'utils/formatPrice';

const getOrderTotalCharge = ({ orderLine, value, part, caloricUnitsSupport }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  let totalCharge = orderLine
    ? orderLine.reduce((accumulator, currentValue) => {
      if (!currentValue.Charge) {
        return accumulator;
      }
      const charge = typeof currentValue.Charge === 'number'
        ? currentValue.Charge : Number(currentValue.Charge.replace('$', ''));
      const units = caloricUnitsSupport && currentValue['Calories Per Unit']
        ? Math.ceil(currentValue.Units * currentValue['Calories Per Unit'] / 100) : currentValue.Units;
      return accumulator + (charge * units);
    }, 0)
    : null;
  if (!totalCharge) {
    return null;
  }
  totalCharge = formatPrice(totalCharge).replace('$', '');
  switch (part) {
    case 'dollars':
      return totalCharge.split('.')[0] || '';
    case 'cents':
      return totalCharge.split('.')[1] || '';
    default:
      return totalCharge;
  }
};

export default getOrderTotalCharge;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderTotalCharge.js